import React, { useCallback, useEffect, useState } from 'react';
import { approveBankTopup, fetchAdminBankTopups, rejectBankTopup } from '../../services/walletApi';

export default function BankTopupApprovals({ onQueueChange }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchAdminBankTopups('pending');
      const list = data.items || [];
      setItems(list);
      if (onQueueChange) onQueueChange(list.length);
    } catch {
      setItems([]);
      if (onQueueChange) onQueueChange(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleApprove = async (id) => {
    setBusyId(id);
    try {
      await approveBankTopup(id);
      await load();
    } catch (err) {
      alert(err.message || 'Approve failed');
    } finally {
      setBusyId(null);
    }
  };

  const handleReject = async (id) => {
    const note = window.prompt('Rejection note (optional):') || '';
    setBusyId(id);
    try {
      await rejectBankTopup(id, note);
      await load();
    } catch (err) {
      alert(err.message || 'Reject failed');
    } finally {
      setBusyId(null);
    }
  };

  if (loading) return <p className="text-sm text-muted-foreground">Loading bank top-ups…</p>;
  if (items.length === 0) return <p className="text-sm text-muted-foreground">No pending NEFT/IMPS wallet requests.</p>;

  return (
    <div className="space-y-3">
      {items.map((row) => (
        <div
          key={row.id}
          className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-amber-500/30 bg-amber-500/5 p-3 text-sm"
        >
          <div>
            <div className="font-semibold text-amber-200">
              ₹{Number(row.amount).toLocaleString('en-IN')} · {row.method}
            </div>
            <div className="text-xs text-muted-foreground">
              UTR: {row.utr} · User: {row.user_id?.slice(0, 8)}… · {new Date(row.created_at).toLocaleString('en-IN')}
            </div>
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              className="rounded-md bg-emerald-600 px-3 py-1 text-xs font-bold text-white disabled:opacity-50"
              disabled={busyId === row.id}
              onClick={() => handleApprove(row.id)}
            >
              Approve
            </button>
            <button
              type="button"
              className="rounded-md bg-red-700 px-3 py-1 text-xs font-bold text-white disabled:opacity-50"
              disabled={busyId === row.id}
              onClick={() => handleReject(row.id)}
            >
              Reject
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
